import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { formatDateTime, meetingTypeLabel, getDetailPath } from '../../utils/meetingUtils';

import Spinner from '../../components/Spinner/Spinner'
import { toast } from 'react-hot-toast';
import MeetingSearch from './MeetingSearch'
import { getMeetingsPage } from '../../features/meeting/meetingSlice'

function MeetingPastList() {
    const PAGE_SIZE = 15;
    const [filteredMeetings, setFilteredMeetings] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const isVisibleMeeting = (m) => m?.state !== false && m?.state !== 'false';

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.auth);
    const isAuthenticated = useSelector((state) => state.auth.user !== null);
    const { meetings, meetingsPagination, loadingStates, errors, message } = useSelector((state) => state.meeting);
    const isLoading = loadingStates?.getMeetingsPage;
    const loadError = errors?.getMeetingsPage;
    const hasMore = !!meetingsPagination?.hasMore;
    const nextCursor = meetingsPagination?.nextCursor ?? null;

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/login')
        }
    }, [isAuthenticated, navigate])

    useEffect(() => {
        if (!isAuthenticated) return;
        dispatch(getMeetingsPage({ pageSize: PAGE_SIZE, cursor: null, searchTerm, append: false }))
    }, [isAuthenticated, dispatch])

    useEffect(() => {
        if (loadError) {
            toast.error(loadError || message);
        }
    }, [loadError, message])

    useEffect(() => {
        const now = new Date();
        const past = meetings.filter(m => {
            if (!isVisibleMeeting(m)) return false;
            const end = m.endDate?.toDate ? m.endDate.toDate() : new Date(m.endDate);
            return end < now;
        });
        setFilteredMeetings(past);
    }, [meetings]);

    const handleFilteredMeetings = useCallback((filtered) => {
        setFilteredMeetings((filtered || []).filter(isVisibleMeeting));
    }, []);

    if (isLoading) {
        return <Spinner />
    }

    const formatDate = (date) => formatDateTime(date);
    const handleLoadMore = () => {
        if (!hasMore || isLoading) return;
        dispatch(getMeetingsPage({
            pageSize: PAGE_SIZE,
            cursor: nextCursor,
            searchTerm,
            append: true,
        }));
    };

    const handleRefresh = () => {
        dispatch(getMeetingsPage({ pageSize: PAGE_SIZE, cursor: null, searchTerm, append: false }));
    };

    const handleSearchSubmit = (value) => {
        const nextSearch = (value || '').trim();
        setSearchTerm(nextSearch);
        dispatch(getMeetingsPage({ pageSize: PAGE_SIZE, cursor: null, searchTerm: nextSearch, append: false }));
    };

    return (
        <>
            {/* Search Component */}
            <MeetingSearch
                onFilteredMeetings={handleFilteredMeetings}
                onRefresh={handleRefresh}
                onSearch={handleSearchSubmit}
            />
            
            <div className="row">

                {filteredMeetings.length > 0 ? (
                    <>
                        {filteredMeetings.map((meeting, index) => (
                            <div className="col-xl-6 col-xxl-6 col-lg-6 col-md-6 col-sm-6" key={index}>
                                <Link to={getDetailPath(meeting)}>
                                    <div className="card project-boxed">
                                       
                                        <div className="card-header align-items-start">
                                            <div>
                                                <h6 className="fs-18 font-w500 mb-3 text-black user-name">{meeting.title}</h6>
                                                {String(meeting?.status ?? '0') === '1' && (
                                                    <div className="mb-2">
                                                        <span className="badge light badge-danger">Toplantı İptal Edildi</span>
                                                    </div>
                                                )}
                                                <div className="text-dark fs-14 text-nowrap"><i className="fa fa-calendar me-3" aria-hidden="true"></i>{formatDate(meeting.startDate)}</div>
                                                <div className="text-dark fs-14 text-nowrap"><i className="fa fa-briefcase me-3" aria-hidden="true"></i>{meeting.isactivity? "Etkinlik" : "Toplantı"}</div>
                                                <div className="text-dark fs-14 text-nowrap"><i className="fa fa-star me-3" aria-hidden="true"></i>{meetingTypeLabel(meeting.type)}</div>
                                                <div className="text-dark fs-14 text-nowrap"><i className="fa fa-user me-3" aria-hidden="true"></i>{meeting.users?.length} Katılımcı</div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </>
                ) : (
                    <h3>Toplantı Bulunamadı</h3>
                )}
            </div >

            {hasMore && (
                <div className="d-flex justify-content-center mt-4">
                    <button className="btn btn-primary" onClick={handleLoadMore}>
                        {isLoading ? 'Yükleniyor...' : 'Daha Fazla Yükle'}
                    </button>
                </div>
            )}
        </>

    )
}

export default MeetingPastList
